<template>
  <div class="edit-report-cnv-dailog dialog col-block">
    <div class="block-container cnv col-block">
      <div class="title-container">
        <div
          class="title"
          v-html="{
            'type': $t('DIALOG.editReportCNV.___typeTitle'),
            'GT': $t('DIALOG.editReportCNV.___gtTitle'),
            'intron': $t('DIALOG.editReportCNV.___intronTitle'),
            'length': $t('DIALOG.editReportCNV.___lengthTitle')
          }[type]"
        ></div>
        <div :style="{ flex: 1 }"></div>
      </div>
      <div :style="{ height: '10px' }"></div>
      <div class="cnv-container col-block flex-start">
        <div class="cnv-title" v-html="'<b>SV</b>' + ' ' + cnv.CHROM + ':' + cnv.POS_START + '-' + cnv.POS_END"></div>
      </div>
    </div>
    <div :style="{ height: '15px' }"></div>
    <template v-if="type === 'type'">
      <div class="block-container form col-block">
        <div class="title-container">
          <div class="title" v-html="$t('DIALOG.editReportCNV.cnvForm.title.___type')"></div>
          <div :style="{ flex: 1 }"></div>
        </div>
        <div :style="{ height: '10px' }"></div>
        <div class="form-container row-block">
          <div class="form-list-container row-block flex-wrap">
            <div class="form-item-container" v-for="(item, index) in formItems['type']" :key="index">
              <div class="form-item row-block" @click="e => setValue('type', item)">
                <img :class="{ multiple: multiple['type'] }" :src="result['type'].includes(item.value) ? require('../../assets/images/' + (multiple['type'] ? 'checkbox': 'radio') + '-true.svg') : require('../../assets/images/' + (multiple['type'] ? 'checkbox': 'radio') + '-false.svg')">
                <div :style="{ width: '8px' }"></div>
                <div class="chapter-title" :style="item.color ? { color: item.color } : {}">{{ item.title }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-if="type === 'GT'">
      <div class="block-container form col-block">
        <div class="form-container input-group row-block">
          <input type="text" v-model="result['GT']" :placeholder="$t('DIALOG.editReportCNV.cnvForm.placeholder.___gt')">
        </div>
      </div>
    </template>
    <template v-if="type === 'intron'">
      <div class="block-container form col-block">
        <div class="form-container input-group row-block">
          <input type="text" v-model="result['intron']" :placeholder="$t('DIALOG.editReportCNV.cnvForm.placeholder.___intron')">
        </div>
      </div>
    </template>
    <template v-if="type === 'length'">
      <div class="block-container form col-block">
        <div class="form-container input-group row-block">
          <input type="text" v-model="result['length']" :placeholder="$t('DIALOG.editReportCNV.cnvForm.placeholder.___length')">
        </div>
      </div>
    </template>
    <template v-if="type === 'Parental Origin'">
      <div class="block-container form col-block">
        <div class="title-container">
          <div class="title" v-html="$t('DIALOG.editReportCNV.cnvForm.title.___parentalOrigin')"></div>
          <div :style="{ flex: 1 }"></div>
        </div>
        <div :style="{ height: '12px' }"></div>
        <div class="form-container row-block">
          <div class="form-list-container row-block flex-wrap">
            <div class="form-item-container" v-for="(item, index) in formItems['ParentalOrigin']" :key="index">
              <div class="form-item row-block" @click="e => setValue('ParentalOrigin', item)">
                <img :class="{ multiple: multiple['ParentalOrigin'] }" :src="result['ParentalOrigin'].includes(item.value) ? require('../../assets/images/' + (multiple['ParentalOrigin'] ? 'checkbox': 'radio') + '-true.svg') : require('../../assets/images/' + (multiple['ParentalOrigin'] ? 'checkbox': 'radio') + '-false.svg')">
                <div :style="{ width: '8px' }"></div>
                <div class="chapter-title" :style="item.color ? { color: item.color } : {}">{{ item.title }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <div :style="{ height: '15px' }"></div>
    <div class="button-container row-block">
      <div :style="{ flex: 1 }"></div>
      <button class="gray-button circle-button" @click="e => $emit('changeModal')">
        <span>{{ $t('COMMON.button.___cancel') }}</span>
      </button>
      <div :style="{ width: '20px' }"></div>
      <button class="main-button circle-button" @click="e => $emit('changeModal', {}, result)">
        <span>{{ $t('COMMON.button.___update') }}</span>
      </button>
      <div :style="{ flex: 1 }"></div>
    </div>
  </div>
</template>

<script>
import { reportCNVTypeMap, reportParentalOriginMap } from '../../constants/global/data'

export default {
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      result: {
        'type': [],
        'GT': '',
        'intron': '',
        'length': '',
        'ParentalOrigin': []
      },
      multiple: {
        'type': false,
        'GT': false,
        'intron': false,
        'length': false,
        'ParentalOrigin': false
      }
    }
  },
  created () {
    this.result = {
      ...this.result,
      ...this.param.value
    }
    this.multiple = {
      ...this.multiple,
      ...this.param.multiple
    }
  },
  computed: {
    formItems () {
      return {
        'type': Object.entries(reportCNVTypeMap).map(([value, title]) => ({ title: title, value: value })),
        'ParentalOrigin': Object.entries(reportParentalOriginMap).map(([value, title]) => ({ title: title, value: value }))
      }
    },
    // param
    type () {
      return this.param.type
    },
    cnv () {
      return { ...this.param.cnv }
    }
  },
  methods: {
    setValue (type, item) {
      if (!this.multiple[type]) {
        this.result[type] = []
      }
      this.result[type] = !this.result[type].includes(item.value) ? this.result[type].concat([item.value]) : this.result[type].length > 1 ? this.result[type].filter(value => value !== item.value) : this.result[type]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/editReportCNV.vue